import React from 'react';
import Breadcrumb from '../../breadcrumb/component.tsx';
import type { BreadcrumbData } from '../../types.tsx';
import type { UserBreadcrumbProps } from './types.tsx';

const UserBreadcrumb = ({ children, name, profileUrl }: UserBreadcrumbProps) => {
	const breadcrumb: BreadcrumbData = {
		href: profileUrl,
		text: name,
		type: 'userName',
	};
	return <Breadcrumb breadcrumb={breadcrumb}>{children}</Breadcrumb>;
};

export default UserBreadcrumb;
